<!-- Created by Max Bon. on 17/08/2020-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->
<div fxLayout="row" fxLayoutAlign="space-between start" class="header m-b-8">
  <h2 class="mat-h2 m-b-0" fxFlex>
    {{inEditNoteMode ? ('shared.studentNotes.editNote' | translate) : ('shared.studentNotes.addNote' | translate)}}
  </h2>
  <curr-icon-button icon="close" (click)="dialogRef.close()"></curr-icon-button>
</div>
<div class="name-container" fxLayout="column" fxLayoutAlign="center center">
  <curr-input class="full-width" [(value)]="comment" placeholder="{{ 'shared.studentNotes.enterComment' | translate }}"></curr-input>
  <div class="m-t-8 full-width" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="highlight-color m-r-16" *ngFor="let c of colors;let i = index"
           [class.selected]="c.checked" (click)="setCheckedColor(i)"
           [style]="{'background-color': c.color}"></div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center">
      <curr-button variant="text" (btnClick)="dialogRef.close()">{{ 'shared.studentNotes.cancel' | translate }}</curr-button>
      <curr-button variant="contained" class="m-l-16" (btnClick)="saveNote()"
      [isDisabled]="!comment.length || !selectedColor.length">
        {{inEditNoteMode ? ('shared.studentNotes.save' | translate) : ('shared.studentNotes.addNote' | translate)}}
      </curr-button>
    </div>

  </div>
</div>
